import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=62b916ae&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=ts"
export * from "./Callback.vue?vue&type=script&lang=ts"
import style0 from "./Callback.vue?vue&type=style&index=0&id=62b916ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b916ae",
  null
  
)

export default component.exports